import { themeColor } from '../../../util/theme';

// Chart series colours. Recharts writes colours into SVG attributes, so it needs
// resolved values, not var(). Call these at render time so a theme toggle picks up
// the new values. The second entry is the light value, used if the token cannot be read.
// theme-ignore-start — fallback values for the tokens named beside them
const CHART_COLORS = {
  retail: ['--color-source-retail', '#2E56F6'],
  orange: ['--color-brand-orange', '#FF9516'],
  green: ['--color-success', '#28a745'],
  purple: ['--color-purple-dark', '#6f42c1'],
  blue: ['--color-brand-blue', '#5196d3'],
  amber: ['--color-warning', '#f59e0b'],
  red: ['--color-danger', '#dc3545'],
  grey: ['--color-text-muted', '#9ca3af'],
  slate: ['--color-text-secondary', '#6b7280'],
};
// theme-ignore-end

export const chartColor = (name) => themeColor(CHART_COLORS[name][0], CHART_COLORS[name][1]);
export const chartColors = (...names) => names.map(chartColor);
